(() => {
  const ROOT = '.announcement-ticker';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getUnitWidth(unit) {
    return Math.ceil(unit.getBoundingClientRect().width);
  }

  function initTicker(section) {
    const viewport = section.querySelector('.announcement-ticker__viewport');
    const track = section.querySelector('.announcement-ticker__track');
    const source = section.querySelector('.announcement-ticker__sequence');
    if (!viewport || !track || !source) return;

    section._atUnitTemplate = source.cloneNode(true);

    if (prefersReducedMotion()) {
      track.classList.add('is-ready');
      track.style.removeProperty('--at-sequence-width');
      return;
    }

    const sync = () => {
      const viewWidth = Math.ceil(viewport.getBoundingClientRect().width);
      if (!viewWidth) return;

      const unit = section._atUnitTemplate.cloneNode(true);
      unit.removeAttribute('aria-hidden');

      const originals = [...unit.children];
      if (!originals.length) return;

      track.replaceChildren(unit);
      track.classList.remove('is-ready');

      let guard = 0;
      while (getUnitWidth(unit) < viewWidth && guard < 40) {
        originals.forEach((child) => {
          unit.appendChild(child.cloneNode(true));
        });
        guard += 1;
      }

      const seqWidth = getUnitWidth(unit);
      if (!seqWidth) return;

      while (track.scrollWidth < viewWidth + seqWidth) {
        const clone = unit.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      const finalWidth = getUnitWidth(unit);
      track.style.setProperty('--at-sequence-width', `${finalWidth}px`);

      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.animation = '';

      track.classList.add('is-ready');
    };

    sync();

    if (section._atResizeObserver) {
      section._atResizeObserver.disconnect();
    }

    let resizeTimer;
    const ro = new ResizeObserver(() => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 120);
    });
    ro.observe(viewport);
    section._atResizeObserver = ro;

    if (document.fonts?.ready) {
      document.fonts.ready.then(sync).catch(() => {});
    }

    window.addEventListener('load', sync, { once: true });

    setTimeout(() => {
      track.classList.add('is-ready');
    }, 2500);
  }

  function initAll(root = document) {
    const scope = root instanceof Element ? root : document;
    scope.querySelectorAll(ROOT).forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
